// src/finance/components/ConfirmDeleteModal.jsx
// Confirmación nativa (bottom sheet móvil)

import React from "react";
import { AlertTriangle } from "lucide-react";
import NativeSheet from "../../components/ui/NativeSheet";
import { useIsMobile } from "../../hooks/useMediaQuery";

const ConfirmDeleteModal = ({ isOpen, title, message, onConfirm, onCancel, isMobile: isMobileProp }) => {
  const isMobileHook = useIsMobile();
  const isMobile = isMobileProp ?? isMobileHook;

  const footer = (
    <div className={`flex gap-2 ${isMobile ? "flex-col-reverse" : "justify-end"}`}>
      <button
        type="button"
        onClick={onCancel}
        className={`rounded-xl font-medium border border-color text-secondary hover:bg-hover transition active:scale-[0.98] ${
          isMobile ? "w-full py-3 text-sm" : "px-4 py-2.5 text-sm"
        }`}
      >
        Cancelar
      </button>
      <button
        type="button"
        onClick={onConfirm}
        className={`rounded-xl font-semibold bg-red-600 hover:bg-red-500 text-white shadow-md shadow-red-600/25 transition active:scale-[0.98] ${
          isMobile ? "w-full py-3 text-sm" : "px-4 py-2.5 text-sm"
        }`}
      >
        Excluir
      </button>
    </div>
  );

  return (
    <NativeSheet open={isOpen} onClose={onCancel} title={title || "Confirmar"} tone="danger" footer={footer}>
      <div className="flex gap-3 items-start">
        <div className="w-11 h-11 rounded-2xl bg-red-50 dark:bg-red-500/10 flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400" />
        </div>
        <p className={`text-secondary leading-relaxed ${isMobile ? "text-sm" : "text-sm md:text-base"}`}>
          {message}
        </p>
      </div>
    </NativeSheet>
  );
};

export default ConfirmDeleteModal;
